import { Grid2 as Grid, type Theme, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import makeStyles from '@mui/styles/makeStyles';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetRegions } from '@/hooks/useGetRegions';
import { FeatureEnum, IndustryTrackerTypeEnum } from '@/types/GraphqlSchema';
import { RegionEnum } from '@/types/RegionEnum';
import { defaultDimensions } from '@/utils/analytics';
import { getUserId } from '@/utils/auth';
import { ANALYTICS_EVENT_ACTIONS, ANALYTICS_EVENTS } from '@/utils/constants';
import { INDUSTRY_TRACKER_IMAGES } from '../../constants';

const useStyles = makeStyles((theme: Theme) => ({
  centeredButton: {
    ...theme.palette.button,
  },
  modalButtons: {
    margin: '15px 0px 30px',
  },
  modalGridItem: {
    minWidth: '190px',
  },
}));

export const MaOpportunitiesLinks = () => {
  const classes = useStyles();

  const regions = Object.values(RegionEnum);
  const { regions: userEntitledRegions } = useGetRegions({
    feature: FeatureEnum.MAndAOpportunities,
  });
  const history = useHistory();

  const onClick = (region: RegionEnum) => {
    gtag('event', ANALYTICS_EVENTS.event, {
      event_category: 'IndustryTrackers',
      event_action: ANALYTICS_EVENT_ACTIONS.download,
      event_label: `M&A Opportunities | ${region}`,
      userId: getUserId(),
      ...defaultDimensions,
    });
    history.push(`/m-a/opportunities?region=${encodeURIComponent(region)}#table`);
  };

  const isUserEntitled = useCallback(
    (region: RegionEnum) => userEntitledRegions.some(r => r.displayName === region),
    [userEntitledRegions],
  );
  const image = INDUSTRY_TRACKER_IMAGES[IndustryTrackerTypeEnum.PotentialMaOpportunities];

  return (
    <Grid className={classes.modalGridItem} size={2} textAlign='center'>
      <img src={image} width='100px' height='65px' alt='ma-opportunities-icon' />
      <Typography variant='h6' style={{ margin: '15px 0' }}>
        Potential M&A Opportunities
      </Typography>
      <Grid
        container
        spacing={1}
        className={classes.modalButtons}
        sx={{ justifyContent: 'center' }}
      >
        {regions.map(region => (
          <Grid key={`ma-opportunities-${region}`}>
            <Tooltip
              title={
                !isUserEntitled(region)
                  ? 'Your current plan does not include access to this file.'
                  : ''
              }
              disableHoverListener={!!isUserEntitled(region)}
              arrow
            >
              <span>
                <Button
                  className={classes.centeredButton}
                  variant='contained'
                  key={`ma-opportunities-${region}`}
                  disabled={!isUserEntitled(region)}
                  onClick={() => onClick(region)}
                >
                  {region || 'Download Data'}
                </Button>
              </span>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
